<div id="sequencing-resources">
    <h1>
        {{ 'dashboard.seqResources.title' | translate }}
    </h1>

    <ul>
        <li>
            <a
                (click)="logLinkClick('dashboard-download-faq')"
                href="assets/documents/YX Sequencing Sanger FAQ.pdf"
                target="_blank"
                >{{ 'dashboard.seqResources.list.faq' | translate }}</a
            >
        </li>
        <li>
            <a
                (click)="logLinkClick('dashboard-download-sanger-sequencing-sample-preparation-guide')"
                href="assets/documents/Sanger Sequencing Sample Preparation Guide.pdf"
                target="_blank"
                >{{ 'dashboard.seqResources.list.sangerSamplePreparation' | translate }}</a
            >
        </li>
        <li>
            <a
                (click)="logLinkClick('dashboard-download-standard-sequencing-primers')"
                href="assets/documents/Standard Sequencing Primers.pdf"
                target="_blank"
                >{{ 'dashboard.seqResources.list.standardSequencingPrimers' | translate }}</a
            >
        </li>
        <li>
            <a
                (click)="logLinkClick('dashboard-download-sanger-results-troubleshooting')"
                href="assets/documents/Sanger Results Troubleshooting.pdf"
                target="_blank"
                >{{ 'dashboard.seqResources.list.sangerResultsTroubleshootingGuide' | translate }}</a
            >
        </li>
        <li>
            <a
                (click)="logLinkClick('dashboard-download-viewing-your-sanger-data')"
                href="assets/documents/Viewing Your Sanger Data.pdf"
                target="_blank"
                >{{ 'dashboard.seqResources.list.viewingYourSangerData' | translate }}</a
            >
        </li>
    </ul>
</div>
